import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http, Response, Headers, RequestOptions, URLSearchParams, ResponseContentType } from '@angular/http';
import { DevelopUtil } from '../../utils/develop.utils';

@Injectable()
export class ReportHttpService {

  public static REPORT_URL = DevelopUtil.url('report/1.77');
  public static REPORT_INVOICE_URL = DevelopUtil.url('report/invoice');
  public static REPORT_SUMMARY_URL = DevelopUtil.url('report/summaryInfo');
  public static REPORT_DEBT_URL = DevelopUtil.url('report/debtInvoice');


  private headers: Headers;
  private requestOptions: RequestOptions;

  constructor(private http: Http) {
    this.headers = new Headers();
    this.requestOptions = new RequestOptions({headers: this.headers});
  }

  getReport(urlSearchParams: URLSearchParams): Observable<Response> {
    this.requestOptions.search = urlSearchParams;
    this.requestOptions.responseType = ResponseContentType.Blob;
    return this.http.get(ReportHttpService.REPORT_URL, this.requestOptions);
  }

  getInvoice(urlSearchParams: URLSearchParams): Observable<Response> {
    this.requestOptions.search = urlSearchParams;
    this.requestOptions.responseType = ResponseContentType.Blob;
    return this.http.get(ReportHttpService.REPORT_INVOICE_URL, this.requestOptions);
  }

  getSummary(urlSearchParams: URLSearchParams): Observable<Response> {
    this.requestOptions.search = urlSearchParams;
    this.requestOptions.responseType = ResponseContentType.Blob;
    return this.http.get(ReportHttpService.REPORT_SUMMARY_URL, this.requestOptions);
  }

  getDebtInvoice(urlSearchParams: URLSearchParams): Observable<Response> {
    this.requestOptions.search = urlSearchParams;
    this.requestOptions.responseType = ResponseContentType.Blob;
    return this.http.get(ReportHttpService.REPORT_DEBT_URL, this.requestOptions);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/report/report.http.service.ts